import { createUseStyles } from 'react-jss'

import { TextSlateGreyDarken12 } from '../../const/colors'
import { WidthBPs } from '../../const/commonStyles'
import { FontBody1 } from '../../const/fontStyles'

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
      position: 'relative',
      maxWidth: 709,
      left: 0,
      right: 0,
      padding: '0 0 24px',
      margin: 0,

      '& > * + *': {
        margin: '10px 0 0',
      },

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        padding: '0 40px',
        flexDirection: 'row',
        bottom: 48,
        position: 'absolute',
        margin: 'auto',

        '& > * + *': {
          margin: '0 0 0 10px',
        },
      },
    },
    text: {
      ...FontBody1,
      color: TextSlateGreyDarken12,
      marginRight: 12,
      flexShrink: 0,
    },
    block: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',

      '&:last-of-type': {
        justifyContent: 'flex-start',
      },

      [`@media (min-width: ${WidthBPs.EXTRA_SMALL})`]: {
        '&:last-of-type': {
          justifyContent: 'flex-end',
        },
      },
    },
    button: {
      flexGrow: 0,
    },
  },
  { name: 'SupportFooter' }
)
